import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font } from '../theme/base/mixins';
import { StyledAnchorComponent, StyledDivComponent } from '../types';
import { FontIcon, FontIconProps } from './FontIcon';
import { SvgIcon, SvgIconProps } from './SvgIcon';

type SocialIconProps = FontIconProps;
type SocialIconSvgProps = SvgIconProps;

export const SocialIcon: StyledAnchorComponent<
  SocialIconProps
> = FontIcon.withComponent('a').extend<SocialIconProps>`
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  color: ${(props) => props.theme.colors.secondary};

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }

  ${(props) =>
    props.icon === 'facebook' &&
    css`
      font-size: 24px;
    `}

  ${(props) =>
    props.icon === 'twitter' &&
    css`
      font-size: 28px;
      vertical-align: -3px;
    `}

  ${(props) =>
    props.icon === 'mail' &&
    css`
      font-size: 22px;
      vertical-align: -3px;
    `}

  ${(props) =>
    props.icon === 'linkedin' &&
    css`
      font-size: 24px;
      vertical-align: baseline;
    `}
`;

export const SocialIconSvg: StyledAnchorComponent<
  SocialIconSvgProps
> = SvgIcon.extend<SocialIconSvgProps>`
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  fill: ${(props) => props.theme.colors.stickyBg};

  &:hover {
    fill: ${(props) => props.theme.colors.primary};
  }

  ${(props) =>
    props.icon === 'copy' &&
    css`
      vertical-align: baseline;
    `}
`;

export const SvgClickableContainer = styled.div`
    display: inline-flex;
`;

export const SocialIcons: StyledDivComponent = styled.div`
  display: inline-block;
`;

export const SocialContainer: StyledDivComponent = styled.div`
  ${font(2.2, 2.4, '500')};
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.secondary};
  margin: 15px 0 100px 0;
  text-align: right;
`;

export const SocialText = styled.span`
  margin: 0 34px 0 0;
  vertical-align: top;
`;

export const SocialLinks = styled.div`
  display: inline-block;
`;
